import { FC, memo } from "react";

const Alert: FC = () => {
  return (
    <>
      <svg
        width="19"
        height="19"
        viewBox="0 0 19 19"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9.50004 1.58203C5.13004 1.58203 1.58337 5.1287 1.58337 9.4987C1.58337 13.8687 5.13004 17.4154 9.50004 17.4154C13.87 17.4154 17.4167 13.8687 17.4167 9.4987C17.4167 5.1287 13.87 1.58203 9.50004 1.58203ZM10.2917 13.457H8.70837V11.8737H10.2917V13.457ZM10.2917 10.2904H8.70837V5.54036H10.2917V10.2904Z"
          fill="#E52514"
        />
      </svg>
    </>
  );
};

export default memo(Alert);
